var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.604 43.23C23.0468 43.4883 23.2682 43.6175 23.5806 43.6845C23.8231 43.7365 24.1769 43.7365 24.4194 43.6845C24.7318 43.6175 24.9532 43.4883 25.396 43.23C29.2921 40.957 40 33.8171 40 24.0002V14.4354C40 12.8364 40 12.0369 39.7385 11.3496C39.5075 10.7425 39.132 10.2008 38.6447 9.77129C38.093 9.28511 37.3444 9.00438 35.8472 8.44293L25.1236 4.42158C24.7078 4.26566 24.4999 4.1877 24.286 4.15679C24.0963 4.12938 23.9037 4.12938 23.714 4.15679C23.5001 4.1877 23.2922 4.26566 22.8764 4.42158L12.1528 8.44293C10.6556 9.00438 9.90699 9.28511 9.35532 9.77129C8.86797 10.2008 8.49255 10.7425 8.26152 11.3496C8 12.0369 8 12.8364 8 14.4354V24.0002C8 33.8171 18.7079 40.957 22.604 43.23Z",
    stroke: "#5732AB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield1);
export default __webpack_public_path__ + "static/media/shield_1.d98fe3394b4f341501735ed068d79f5d.svg";
export { ForwardRef as ReactComponent };